/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function (Drupal, $, once) {
  Drupal.behaviors.mainMenu = {
    attach: function (context) {
      "use strict";
      once("custom-header-behavior", ".header.simple-menu", context).forEach(
        function () {
          $(document).on(
            "click",
            ".main-nav> .main-menu.level-0> .main-menu__item--with-sub>button",
            function (e) {
              e.stopPropagation();
              var item = $(this).parent();

              if (window.matchMedia("(min-width: 1200px)").matches) {
                if (item.hasClass("is-open")) {
                  item.removeClass("is-open");
                  item
                    .children(".menu_second_level__wrapper")
                    .removeClass("expanded")
                    .stop()
                    .slideUp(300);
                  $(".bg-dark").removeClass("active");
                } else {
                  $(
                    ".main-nav> .main-menu.level-0> .main-menu__item--with-sub.is-open"
                  ).removeClass("is-open");
                  $(".menu_second_level__wrapper.expanded").stop().slideUp(300);
                  item.addClass("is-open");
                  item
                    .children(".menu_second_level__wrapper")
                    .addClass("expanded")
                    .stop()
                    .slideDown(300);
                  $(".bg-dark").addClass("active");
                }
              }
            }
          );
          $(document).on(
            "click",
            ".menu_second_level__wrapper button.close",
            function () {
              $(this)
                .closest(".menu_second_level__wrapper")
                .removeClass("expanded")
                .stop()
                .slideUp(300);
              $(this)
                .closest(".main-menu__item.is-open")
                .removeClass("is-open");
              $(".bg-dark").removeClass("active");
            }
          );

          //Close menu on blur
          $(document).mouseup(function (e) {
            if (window.matchMedia("(min-width: 1200px)").matches) {
              var container = $(
                ".main-nav> .main-menu.level-0> .main-menu__item--with-sub.is-open"
              );
              // if the target of the click isn't the container nor a descendant of the container
              if (
                !container.is(e.target) &&
                container.find(e.target).length === 0
              ) {
                container.removeClass("is-open");
                container
                  .find(".menu_second_level__wrapper")
                  .removeClass("expanded")
                  .stop()
                  .slideUp(300);
                $(".bg-dark").removeClass("active");
              }
            }
          });

          $(document).on("click", ".bg-dark.active", function () {
            $(this).removeClass("active");
            if (window.matchMedia("(min-width: 1200px)").matches) {
              $(
                ".main-nav> .main-menu.level-0> .main-menu__item--with-sub.is-open"
              ).removeClass("is-open");
              $(".menu_second_level__wrapper.expanded").stop().fadeOut(300);
            } else {
              $("#search-block-form").stop().slideUp(200);
              $(".header.simple-menu #block-afma-main-menu")
                .stop()
                .slideUp(200);

              $(".hamburger-menu__wrapper, .search-icon").removeClass("active");
            }
          });

          //Search Desktop
          $(".top-menu [id^='block-searchform'] input[type=search]").on(
            "focus",
            function () {
              if (window.matchMedia("(min-width: 1200px)").matches) {
                $(this).parent().addClass("search-open");

                $(document).mouseup(function (e) {
                  var container = $(
                    "[id^='block-searchform'] .js-form-item-keys"
                  );
                  if (
                    !container.is(e.target) &&
                    container.find(e.target).length === 0
                  ) {
                    container.removeClass("search-open");
                  }
                });
              }
            }
          );

          $(".top-menu [id^='block-searchform'] input[type=search]").on(
            "keyup",
            function () {
              var form = $(this).closest("form");

              if ($(this).val().length > 0) {
                if (!form.children(".search-clear").length) {
                  form.append(
                    '<button class="search-clear" type="button" title="Clear the search"></button>'
                  );
                }
              } else {
                form.children(".search-clear").remove();
              }

              //fixing search autocomplete missing search all term
              var target = document.querySelector(
                "#search-block-form .ui-menu.ui-widget"
              );

              var MutationObserver =
                window.MutationObserver || window.WebKitMutationObserver;

              var observer = new MutationObserver(function (mutations) {
                mutations.some(function (mutation) {
                  if (mutation.type === "childList") {
                    if (
                      !$("#search-block-form .ui-menu.ui-widget>.ui-menu-item")
                        .last()
                        .hasClass("ui-menu-item-first")
                    ) {
                      $("#search-block-form .ui-menu.ui-widget").append(
                        `<div class="ui-autocomplete-field-group ui-state-disabled more_results ui-menu-divider ui-widget-content" aria-disabled="true"></div><li class="ui-menu-item-first ui-menu-item overriden-search"><a id="ui-id-7" tabindex="-1" class="ui-menu-item-wrapper"><div class="ui-autocomplete-fields first"><div class="ui-autocomplete-field">See all results</div></div></a></li>`
                      );
                    }
                  }
                });
              });

              var config = { childList: true };
              observer.observe(target, config);

              $(document).on("click", ".overriden-search", function () {
                $(
                  ".top-menu [id^='block-searchform'] .form-actions .button"
                ).click();
              });
            }
          );

          $(document).on(
            "click",
            "[id^='block-searchform'] .search-clear",
            function () {
              $(this).closest("form").find("input[type=search]").val("");
              $(this).remove();
            }
          );

          //MOBILE
          //merging menus
          const menuBreakpoint = window.matchMedia("(min-width: 1200px)");
          function mergeMenus() {
            if (window.matchMedia("(min-width: 1200px)").matches) {
              $("#block-afma-main-menu ul.main-menu >li.temporary").remove();
              $("#block-afma-main-menu").removeClass("mobile-menu");
            } else if (
              !$("#block-afma-main-menu ul.main-menu >li.temporary").length
            ) {
              $("#block-afma-main-menu").addClass("mobile-menu");
              $("#block-afma-main-menu ul.main-menu").append(
                $("#block-topmenu ul.main-menu > li")
                  .clone()
                  .addClass("temporary")
              );
            }

            if (!window.matchMedia("(min-width: 1200px)").matches) {
              const mobileOnlyControls = document.querySelector(
                "#block-afma-main-menu .mobile-only-controls.home"
              );
              if (mobileOnlyControls) {
                const lastLink = document.querySelector(
                  "[id^=block-toplinks] .field--name-field-links .field__item:last-of-type a"
                );
                if (lastLink) {
                  const clonedLink = lastLink.cloneNode(true);
                  clonedLink.classList.add("fish");
                  
                  const hasFishLink =  mobileOnlyControls.querySelector('.fish');

                  if (!hasFishLink) {
                    mobileOnlyControls.insertBefore(
                      clonedLink,
                      mobileOnlyControls.firstChild
                    );
                  }
                }
              }
            }
          }
          mergeMenus();
          menuBreakpoint.addEventListener('change', () => {
            mergeMenus();
          })


          //Hamburger
          $(".hamburger-menu__wrapper").on("click", function () {
            $(this).toggleClass("active");
            $(".header.simple-menu #block-afma-main-menu")
              .stop()
              .slideToggle(300);

            //Hiding search
            $("#search-block-form").stop().slideUp(200);
            $(".search-icon").removeClass("active");

            $(this).hasClass("active")
              ? $(".bg-dark").addClass("active")
              : $(".bg-dark").removeClass("active");
          });

          //Search
          $(".search-icon").on("click", function () {
            $(this).toggleClass("active");
            $("#search-block-form").stop().slideToggle(200);

            //Hiding Menu
            $(".header.simple-menu #block-afma-main-menu").stop().slideUp(300);
            $(".hamburger-menu__wrapper").removeClass("active");

            $(this).hasClass("active")
              ? $(".bg-dark").addClass("active")
              : $(".bg-dark").removeClass("active");
          });

          //Mobile nav
          //first level
          $(document).on(
            "click",
            "#block-afma-main-menu.mobile-menu .main-menu.level-0 >.main-menu__item--with-sub",
            function () {
              var $this = $(this);
              $this.addClass("expanded");
              $this.siblings().fadeOut(250);
              $(".mobile-only-controls.home").fadeOut(250);
              $this.children(".menu_second_level__wrapper").fadeIn(250);
            }
          );
          //second level
          $(document).on(
            "click",
            "#block-afma-main-menu.mobile-menu .menu_second_level__wrapper >.container >ul >.main-menu__item--with-sub",
            function () {
              var $this = $(this);
              $this.addClass("expanded");
              $this.siblings().fadeOut(250);
              $this.parent().siblings().fadeOut(250);
              $this.children(".menu_third_level__wrapper").fadeIn(250);
            }
          );
          //Back
          $(document).on(
            "click",
            "#block-afma-main-menu.mobile-menu .mobile-only-controls.back",
            function (e) {
              e.stopPropagation();

              var $this = $(this);
              var parentItem = $this.closest(".expanded");
              parentItem.children(".sustained").fadeOut(250);
              parentItem.removeClass("expanded");
              parentItem.siblings().fadeIn(250);
              if (
                parentItem
                  .children(".sustained")
                  .hasClass("menu_second_level__wrapper")
              ) {
                $(".mobile-only-controls.home").fadeIn(250);
              } else {
                parentItem.parent().siblings().fadeIn(250);
              }
            }
          );

          $(window).on("scroll", function () {
            if ($(window).scrollTop() > 0) {
              $("#global-header").addClass("is-sticky");
            } else {
              $("#global-header").removeClass("is-sticky");
            }
          });
        }
      ); // once

      //Header and footer 'Go fish' links
      once(
        "custom-toplinks-behavior",
        "[id^=block-toplinks] .field--name-field-links .field__item:last-of-type a",
        context
      ).forEach(function (element) {
        $(element).attr("target", "_blank");
      });

      once(
        "custom-menubutton-behavior",
        "[id^=block-menubutton] .menu .menu__link",
        context
      ).forEach(function (element) {
        $(element).attr("target", "_blank");
      });

      //Sidebar work
      // Custom reverse function for arrays
      Array.prototype.reverse =
        Array.prototype.reverse ||
        function () {
          return Array.from(this).reverse();
        };

      const elementsToMove = document.querySelectorAll(".move-to-sidebar");
      const sidebar = document.querySelector(".layout-sidebar-second");

      if (elementsToMove.length > 0 && sidebar) {
        const reversedElements = Array.from(elementsToMove).reverse();

        reversedElements.forEach(function (element) {
          sidebar.appendChild(element);
          $(element).fadeIn(300);
        });
      }
    },
  };
})(Drupal, jQuery, once);
